import React from "react";
import { RenderIcon } from "../../../../assets/svg/RenderIcon";
import styles from "./RenderImageButton.module.scss";
import { useAppDispatch } from "../../../../redux/store";
import { changeShowModal } from "../../../../redux/reducers/app/appReducer";

export const RenderImageButton = () => {
  const dispatch = useAppDispatch();

  const handleOpenRenderImage = () => {
    const DoNotShowNote = sessionStorage.getItem("dontShowNote");
    // if (serverStatus === "offline") {
    // dispatch(
    //   changeShowModal({
    //     nameModal: "serverOffline",
    //     stateModal: true,
    //   })
    // );
    // } else {
    if (DoNotShowNote === "true") {
      dispatch(
        changeShowModal({ nameModal: "renderLoader", stateModal: true })
      );
    } else {
      dispatch(changeShowModal({ nameModal: "pleaseNote", stateModal: true }));
    }
    // }
  };

  return (
    <button
      className={styles.render}
      onClick={handleOpenRenderImage}
      data-tour="render-button"
    >
      <RenderIcon />
      Render
    </button>
  );
};
